import React from 'react';
import { EditOutlined, DeleteOutlined, SettingOutlined } from '@ant-design/icons';
import { Card, Skeleton, Tooltip } from 'antd';

import { Dropdown } from "react-bootstrap";
import AssignUsers from '../AssignUsers/AssignUsers';
import { useState } from 'react';
import Avatar from '@material-ui/core/Avatar';
import AvatarGroup from '@material-ui/lab/AvatarGroup';
import { deepOrange, deepPurple } from '@material-ui/core/colors';
import { makeStyles } from '@material-ui/core/styles';
import { useHistory } from 'react-router-dom';
import { baseUrl } from '../../../services/config';
import { PremissionChecker } from '../../../services/PremissionChecker';
import { useSelector } from 'react-redux';
import { toast } from 'react-hot-toast';
import { FaAngleDown } from "react-icons/fa";
import {UserSwitchOutlined} from '@ant-design/icons'

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        '& > *': {
            margin: theme.spacing(1),
        },
    },
    orange: {
        color: theme.palette.getContrastText(deepOrange[500]),
        backgroundColor: deepOrange[500],
    },
    purple: {
        color: theme.palette.getContrastText(deepPurple[500]),
        backgroundColor: `#${Math.floor(Math.random() * 16777215).toString(16)}`,
    },
}));


const { Meta } = Card;


const HolidayGroupCard = ({
    loading,
    item,
    onEditClick,
    onDeleteClick,
    refresh,
    callBackFun
}) => {

    const classes = useStyles();
    const history = useHistory()
    const [assignModal, setAssignModal] = useState(false)
  const customReload=()=>{
    refresh()
    gotToCalendar(item.id)
  }
console.log(item,"this is")

    const groupDropDown = () => {

        return (
            <>
            {/* <Dropdown className="dropdown-inline" drop="down" alignRight>
                <Dropdown.Toggle
                    className="btn btn-sm font-weight-bolder dropdown-toggle px-5"
                    variant="transparent"
                    id="dropdown-toggle-top">
                </Dropdown.Toggle>
                <Dropdown.Menu className="dropdown-menu dropdown-menu-sm dropdown-menu-right">
                    <ul className="navi navi-hover">
 
                        <li className="navi-item">
                            <div
                                onClick={() => setAssignModal(true)}
                                className="navi-link">
                               
                                <span className="navi-text">Edit assignments</span>
                            </div>
                        </li>

                    </ul>
                </Dropdown.Menu>

          

            </Dropdown> */}
             <UserSwitchOutlined onClick={() => setAssignModal(true)}  style={{ color: "orange" }}/>
            {/* <FaAngleDown
            onClick={() => setAssignModal(true)}
            /> */}
            {assignModal ?  <AssignUsers
                    permission={PremissionChecker(user, "holiday_group.assign_user")}
                    getassignUrl={`${baseUrl}/mgmt/leave-groups/${item.id}/assigned-users`}
                    postassignUrl={`${baseUrl}/mgmt/leave-groups/${item.id}/assign-users`}
                    rotaId={item.id}
                    visible={assignModal}
                    setModalVisibility={(bol) => setAssignModal(bol)}
                    refresh={customReload}

                />:''}
            </>
            
        )
    }




    const getColor = () => {
        let color = ''

        color = Math.floor(Math.random() * 16777215).toString(16)
        return color
    }





    // const updatedUsers = item.users.map(user => ({
    //     ...item,
    //     color: getColor()
    // }))



    const user = useSelector(state => state.user.user)

    const gotToCalendar = (id) => {
        if(PremissionChecker(user,'leave_calendar.show')){
            callBackFun(id)
            // history.push(url)

        }else{
            toast.error("Do Not Have Permission")
        }
    }

    return (
        <Card
            hoverable
            style={{
                width: 270,
                margin: 10
            }}
            cover={
                <img
                    // onClick={() => gotToCalendar(`/group/${item.id}/${item.name}`)}
                    onClick={() => gotToCalendar(item.id)}
                    alt="example"
                    src="/rota-planner-group.png"
                />

            }
            actions={[
                PremissionChecker(user,"holiday_group.assign_user")?
                groupDropDown():null,
                PremissionChecker(user,"holiday_group.update")?
                <EditOutlined className='text-primary' onClick={() => onEditClick(item)} key="edit" />:null,
                PremissionChecker(user,"holiday_group.delete")?<DeleteOutlined className='text-danger' onClick={() => onDeleteClick(item)} key="delete" />:null,
            ]}
            loading={loading}
        >
            <Skeleton loading={loading} avatar active>
                <div
                     onClick={() => gotToCalendar(item.id)}
                >
                    
                    <Meta
                        // avatar={<Avatar src="https://joeschmoe.io/api/v1/random" />}
                        title={<Tooltip title={item.name}>{item.name.length>27 ? item.name.slice(0,27)+'..':item.name}</Tooltip>}
                        description="Job Scheduling"
                    />
                   
                </div>

                <div
                  onClick={() => gotToCalendar(item.id)}
                  className='d-flex align-items-center justify-content-between'>
                    <div>
                        <h6>Assigned:</h6>
                    </div>
                    <div>
                        <AvatarGroup max={4}>
                            {
                                item.users.map((usr) => (
                                    <Avatar style={{ backgroundColor: `#${usr.color}` }} alt={usr?.username?.toUpperCase()} src="#" />
                                ))
                            }
                            {/* <Avatar className={classes.orange} alt="Travis Howard" src="/static/images/avatar/2.jpg" /> */}
                            {/* <Avatar className={classes.purple} alt="Agnes Walker" src="/static/images/avatar/4.jpg" /> */}

                        </AvatarGroup>
                    </div>

                </div>

            </Skeleton>

        </Card>
    )
}
export default HolidayGroupCard;

